export default {
  overview: {
    title: "Materialien Übersicht",
    archive_title: "Archivierte Materialien",
    subtitle: "Auflistung aller Materialien.",
    actions: {
      create_new: "Neues Material erstellen",
    },
    search: {
      placeholder: "bspw. Name",
    },
    table: {
      headers: {
        id: "ID",
        name: "Bezeichnung",
        unit: "Abrechnungseinheit",
        purchasePrice: "Einkaufspreis",
        createdAt: "Erstellt am",
      },
      empty: {
        purchasePrice: "Nicht gesetzt",
      },
    },
  },
  detail: {
    title: "Material Details",
    actions: {
      update: "Speichern",
    },
    tabs: {
      general: "Allgemein",
      purchase: "Einkauf",
      files: "Dateiablage",
      activity: "Protokoll",
    },
    form: {
      name: "Name",
      unit: "Einheit",
      purchasePrice: "Einkaufspreis",
      purchaseUnit: "Einkaufspreis Einheit",
      note: "Notizen",
      sections: {
        base_data: "Stammdaten",
        purchase: "Einkauf",
        note: "Notiz",
      },
    },
  },
  create: {
    title: "Material Anlegen",
    subtitle: "Neues Material anlegen.",
  },
  component: {
    autocomplete: {
      noDataText: "Material nicht gefunden {value}",
    },
  },
}
